'use strict';

export default (API) => ({
    services: {
        get: (establishmentId, serviceId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getServiceTemplates: () => {
            const url = 'v3/services/serviceTemplates';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getServiceTemplateSeo: (serviceSeoId) => {
            const url = 'v3/services/serviceTemplates/' + serviceSeoId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getCategories: () => {
            const url = 'v3/portal/categories';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAvailable: () => {
            const url = 'v3/services/available';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllAvailableByEstablishment: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/available';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllAssociatedServiceTemplateByEstablishment: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/associated';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllAssociatedServiceTemplateByEstablishmentWithStatus: (establishmentId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/associated?withStatus=true';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        associateServiceTemplate: (establishmentId, serviceTemplateId, moduleId, submodules) => {
            const url = `v3/establishments/${establishmentId}/services/${serviceTemplateId}/associate`;
            const data = {
                module: moduleId,
                submodules: submodules,
            };
            const request = API.http.post(url, data, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        dissociateServiceTemplate:(establishmentId, serviceTemplateId) => {
            const url = `v3/establishments/${establishmentId}/services/${serviceTemplateId}/dissociate`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        instantiateService: (establishmentId, serviceTemplateId, params) => {
            const url = `v3/establishments/${establishmentId}/services/${serviceTemplateId}/instantiateService`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
        getPlaceAndResourceIndexes: (establishmentId, serviceId) => {
            const url = 'v3/establishments/' + establishmentId + '/places/resources/services/' + serviceId + '/indexes';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllByEstablishment: (establishmentId, module = null, ignorePrest = false, withSettings = false) => {
            let url = `v3/establishments/${establishmentId}/services`;
            if (withSettings) {
                url += `?settings=${withSettings}`;
            }
            if (module) {
                url += `${withSettings ? '&' : '?'}module=${module}`;
            }

            if (ignorePrest) {
                url += `${module || withSettings ? '&' : '?'}ignorePrest=${ignorePrest}`;
            }
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllEstablishmentServices: (establishmentId) => {
            const url = `v3/establishments/${establishmentId}/services/all`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getArchived: (establishmentId) => {
            const url = `v3/establishments/${establishmentId}/services/archived`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllMetaData: () => {
            const url = 'v3/metadata';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getEstMetadata: (establishmentId, serviceId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/metadata/available';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getEstConfigurationMessages: (establishmentId, serviceId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/configuration/messages';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllEstSpecificSettings: (establishmentId, settingIds) => {
            const values = settingIds.join(',');
            const url = 'v3/establishments/' + establishmentId + '/services/settings?settingIds=' + values;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        insertOrUpdateEstConfigurationMessages: (establishmentId, estId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + estId + '/configuration/messages';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getBasicMeta: () => {
            const url = 'v3/services/metas';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getEstSettings: (establishmentId, serviceId) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/settings';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getTemplates: () => {
            const url = 'v3/services/templates';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getServiceTemplatesFilters: (establishmentId, serviceUnifiedId, light = false) => {
            const serviceUnified = serviceUnifiedId ? `&service_unified=${serviceUnifiedId}` : '';
            const isLight = light ? '&light=true' : '';
            const url = 'v3/establishments/' + establishmentId + '/services/templates/filters?' + serviceUnified + isLight;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getByIds(establishmentId, servicesIds) {
            const url = `v3/establishments/${establishmentId}/findByIds?ids=${servicesIds}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createTemplate: (params) => {
            const url = 'v3/services/templates';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateTemplate: (templateId, params) => {
            const url = 'v3/services/templates/' + templateId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteTemplate: (templateId) => {
            const url = 'v3/services/templates/' + templateId;
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getEstSu: (estId, templateId) => {
            const url = '/v3/establishments/services/' + estId + '/unified';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        putEstSu: (estId, params) => {
            const url = '/v3/establishments/services/' + estId + '/unified';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        getModules: () => {
            const url = 'v3/services/modules';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createUninstantiatedServices: (establishmentId, serviceTemplateId, moduleId, submodules) => {
            const url = `v3/establishments/${establishmentId}/services/available`;
            const data = {
                serviceTemplateId: serviceTemplateId,
                module: moduleId,
                submodules: submodules,
            };
            const request = API.http.post(url, data, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteUninstantiatedServices: (establishmentId, establishmentServiceTemplateId) => {
            const url = `v3/establishments/${establishmentId}/services/available/${establishmentServiceTemplateId}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        instantiate: (establishmentId, serviceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/instantiate';
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
        restore: (establishmentId, serviceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/restore';
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        delete: (establishmentId, serviceId, validate) => {
            const url = `v3/establishments/${establishmentId}/services/${serviceId}?validate=${validate}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        update: (establishmentId, serviceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        updateStatus: (establishmentId, serviceId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/status';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateOrder: (establishmentId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/order';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        uploadDocument: (establishmentId, serviceId, language, file) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/upload/' + language;
            const params = new FormData();
            params.append('document', file, file.name);

            const request = API.http.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } });
            return API.handleError(request);
        },
        deleteDocument: (establishmentId, serviceId, language) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceId + '/upload/' + language + '/delete';
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        createServiceMeta: (serviceTemplateId, params) => {
            const url = 'v3/establishments/services/' + serviceTemplateId + '/metadata';
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
        deleteServiceMeta: (serviceTemplateId, metaId) => {
            const url = 'v3/establishments/services/' + serviceTemplateId + '/metadata/' + metaId;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        updateServiceMetas: (establishmentId, serviceTemplateId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceTemplateId + '/metadata';
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        updateServiceSettings: (establishmentId, serviceTemplateId, params) => {
            const url = 'v3/establishments/' + establishmentId + '/services/' + serviceTemplateId + '/settings';
            const request = API.http.put(url, params);
            return API.handleError(request);
        },
        getAllChildrenServiceUnified: () => {
            const url = 'v3/services/unified';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getServicesUnifiedServiceTemplateByServiceTemplate: (serviceTemplateId) => {
            const url = 'v3/services/templates/' + serviceTemplateId + '/unifiedTemplates';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getEstServiceUnifiedAssociationsByServiceUnified: (establishmentId, serviceUnifiedId) => {
            const url = 'v3/establishments/' +  establishmentId + '/unified/' + serviceUnifiedId + '/service';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createServiceUnifiedServiceTemplateAssociations: ($params) => {
            const url = 'v3/services/unifiedTemplates';
            const request = API.http.post(url, $params);
            return API.handleError(request);
        },
        deleteServiceUnifiedServiceTemplateAssociations: (associationId) => {
            const url = 'v3/services/unifiedTemplates/' + associationId;
            const request = API.http.delete(url, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
    },
});
